import React from "react";
import { Modal } from "antd";
import CgIcon from "./CgIcon";
/*
 * The dialog Sale Entry asks with, worn by the purchase screens too.
 *
 * Sale Entry's own DiscardEntryModal speaks about medicines, patients and
 * bills, none of which a purchase entry has - but the question is the same
 * question and should look like the same question, so the shell and its
 * styles are shared and only the words are passed in.
 */
import styles from "../Orders/saleEntry.module.css";

const LeaveWithoutSavingModal = ({
  open,
  title = "Leave without saving?",
  heading = "These changes have not been saved",
  detail,
  saveLabel = "Save changes",
  discardLabel = "Leave without saving",
  saving,
  working,
  onKeepEditing,
  onSave,
  onDiscard,
}) => (
  <Modal
    className={styles.seDialog}
    open={open}
    centered
    width={460}
    maskClosable={!working && !saving}
    onCancel={working || saving ? undefined : onKeepEditing}
    closeIcon={<span className={styles.iactGlyph}>✕</span>}
    title={<div className={styles.seModalT}>{title}</div>}
    footer={
      <div className={styles.seModalF}>
        <div style={{ flex: 1 }} />
        {/*
          * Saving is offered first, but quietly: leaving without saving is the
          * decision being asked about, so it is the one carrying the weight.
          * Closing the dialog goes back to editing.
          */}
        {onSave ? (
          <button
            type="button"
            className={`${styles.btn} ${styles.btnO}`}
            disabled={working || saving}
            onClick={onSave}
          >
            {saving ? "Saving…" : saveLabel}
          </button>
        ) : null}
        <button
          type="button"
          className={`${styles.btn} ${styles.btnD}`}
          disabled={working || saving}
          onClick={onDiscard}
        >
          {working ? "Leaving…" : discardLabel}
        </button>
      </div>
    }
  >
    <div className={styles.seAsk}>
      <span className={`${styles.seAskIco} ${styles.seAskIcoCalm}`}>
        <CgIcon name="info" size={19} stroke={1.9} />
      </span>
      <div>
        <div className={styles.seAskT}>{heading}</div>
        <div className={styles.seAskS}>{detail}</div>
      </div>
    </div>
  </Modal>
);

export default LeaveWithoutSavingModal;
